<template>
  <input
    class="config-dynamic-input"
    :value="value"
    :style="inputStyle"
    type="number"
    placeholder="content..."
    @input="emitInput"
  />
</template>

<script>
export default {
  name: 'ConfigNumberElement',
  props: {
    value: {
      type: [Number, String],
      default: null
    },
    defaultStyle: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    inputStyle () {
      return {
        borderColor: this.defaultStyle.borderColor,
        backgroundColor: this.defaultStyle.backGroundColor
      }
    }
  },
  methods: {
    emitInput (event) {
      const value = event.target.value
      this.$emit('input', value === '' ? '' : Number(value))
    }
  }
}
</script>

<style lang="scss" scoped>
.config-dynamic-input {
  width: 100%;
  height: 30px;
  border: 1px solid #dfe5ed;
  border-radius: 4px;
  background: #ffffff;
  padding: 0 10px;
  font-size: var(--text-xs2);
  outline: none;

  &:focus {
    border-color: var(--brand-color);
  }
}
</style>
